var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEritrea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M24-.003H0V8h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M0 16.002L24 8 0-.003v16.005z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M8.19 8.473a1.582 1.582 0 01-1.11 1.5V8.944l.675-.668-.675-.667v-.555h-.945V8l-.667.668.667.675v.637a1.582 1.582 0 01-1.102-1.5v-.953a1.582 1.582 0 113.157 0v.946zM6.608 5A2.527 2.527 0 004.08 7.527v.946a2.527 2.527 0 105.055 0v-.946A2.528 2.528 0 006.608 5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEritrea);
export default __webpack_public_path__ + "static/media/Eritrea.68904ff50c67c5b19de4affef1f12347.svg";
export { ForwardRef as ReactComponent };